var React = require('react');

function FlagTh (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.2 423.7H8.8c-4.9 0-8.8-4-8.8-8.8V97.1c0-4.9 4-8.8 8.8-8.8h494.3c4.9 0 8.8 4 8.8 8.8v317.8c.1 4.9-3.9 8.8-8.7 8.8z","fill":"#f5f5f5","key":0}),React.createElement("g",{"fill":"#ff4b55","key":1},React.createElement("path",{"d":"M503.2 423.7H8.8c-4.9 0-8.8-4-8.8-8.8v-44.1h512v44.1c0 4.9-4 8.8-8.8 8.8zM8.8 88.3h494.3c4.9 0 8.8 4 8.8 8.8v44.1H0V97.1c0-4.9 4-8.8 8.8-8.8z"})),React.createElement("path",{"fill":"#41479b","d":"M0 194.2h512v123.6H0z","key":2})]);
}

FlagTh.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = FlagTh;

FlagTh.default = FlagTh;
